"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/specialitySection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode, useRef } from "react";

type SpecialitySectionSlideZoomOutDownsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/specialities/speciality-01.jpg" | "/Templates/Doccure/img/specialities/speciality-02.jpg" | "/Templates/Doccure/img/specialities/speciality-03.jpg" | "/Templates/Doccure/img/specialities/speciality-04.jpg" | "/Templates/Doccure/img/specialities/speciality-05.jpg" | "/Templates/Doccure/img/specialities/speciality-06.jpg" | "/Templates/Doccure/img/specialities/speciality-07.jpg" | "/Templates/Doccure/img/specialities/speciality-08.jpg" */
    src: string;
    /** Detected variants: "/Templates/Doccure/img/specialities/speciality-icon-01.svg" | "/Templates/Doccure/img/specialities/speciality-icon-02.svg" | "/Templates/Doccure/img/specialities/speciality-icon-03.svg" | "/Templates/Doccure/img/specialities/speciality-icon-04.svg" | "/Templates/Doccure/img/specialities/speciality-icon-05.svg" | "/Templates/Doccure/img/specialities/speciality-icon-06.svg" | "/Templates/Doccure/img/specialities/speciality-icon-07.svg" | "/Templates/Doccure/img/specialities/speciality-icon-08.svg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "Cardiology" | "Orthopedics" | "Neurology" | "Pediatrics" | "Psychiatry" | "Endocrinology" | "Pulmonology" | "Urology" */
    link0Text: ReactNode;
    /** Detected variants: "254 Doctors" | "151 Doctors" | "176 Doctors" | "124 Doctors" | "112 Doctors" | "104 Doctors" | "41 Doctors" | "39 Doctors" */
    p0Text: ReactNode;
    /** Detected variants: "slide-item wow zoomOutDown" */
    className?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "spaciality-item" */
    div0ClassName?: string;
    /** Detected variants: "spaciality-img" */
    div0ClassName2?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "spaciality-icon" */
    span0ClassName?: string;
    /** Detected variants: "img" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.doctorsGrid" */
    href?: string;
    /** Detected variants: "mb-0" */
    p0ClassName?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false, // we use custom buttons
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeOneSpecialitySectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: SpecialitySectionSlideZoomOutDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: SpecialitySectionSlideZoomOutDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: SpecialitySectionSlideZoomOutDownsItem) => Partial<ComponentProps<"h3">>);
    divDiv0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SpecialitySectionSlideZoomOutDownsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Top Specialties" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Highlighting the" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Care & Support" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1Div0Button0ButtonVisible?: boolean;
    sectionDiv0Div1Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    sectionDiv0Div1Div0Button1ButtonVisible?: boolean;
    sectionDiv0Div1Div0Button1ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Button1ButtonProps?: Partial<ComponentProps<"button">>;
    sectionDiv0Div1Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    specialitySectionSlideZoomOutDowns: SpecialitySectionSlideZoomOutDownsItem[];
    specialitySectionSlideZoomOutDownsItemWrapper?: (item: SpecialitySectionSlideZoomOutDownsItem, content: ReactNode) => ReactNode;
    specialitySectionSlideZoomOutDownsRenderer?: (defaultNode: ReactNode) => ReactNode;
    specialitySectionSlideZoomOutDownsLinkVisible?: boolean;
    specialitySectionSlideZoomOutDownsLinkRenderer?: (item: SpecialitySectionSlideZoomOutDownsItem, defaultNode: ReactNode) => ReactNode;
    specialitySectionSlideZoomOutDownsImageVisible?: boolean;
    specialitySectionSlideZoomOutDownsImageRenderer?: (item: SpecialitySectionSlideZoomOutDownsItem, defaultNode: ReactNode) => ReactNode;
    specialitySectionSlideZoomOutDownsH3Visible?: boolean;
    specialitySectionSlideZoomOutDownsH3Renderer?: (item: SpecialitySectionSlideZoomOutDownsItem, defaultNode: ReactNode) => ReactNode;
    specialitySectionSlideZoomOutDownsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SpecialitySectionSlideZoomOutDownsItem) => Partial<ComponentProps<typeof SmartLink>>);
    specialitySectionSlideZoomOutDownsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: SpecialitySectionSlideZoomOutDownsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    specialitySectionSlideZoomOutDownsH3Props?: Partial<ComponentProps<"h3">> | ((item: SpecialitySectionSlideZoomOutDownsItem) => Partial<ComponentProps<"h3">>);
};

const HomeOneSpecialitySectionGenerated: FC<HomeOneSpecialitySectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Top Specialties",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Highlighting the",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Care & Support",
    sectionDiv0Div1Div0Button0ButtonVisible,
    sectionDiv0Div1Div0Button0ButtonRenderer,
    sectionDiv0Div1Div0Button0ButtonProps,
    sectionDiv0Div1Div0Button1ButtonVisible,
    sectionDiv0Div1Div0Button1ButtonRenderer,
    sectionDiv0Div1Div0Button1ButtonProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Span0ImageWithBasePath0ImageProps,
    divDiv0H30H3Props,
    divDiv0H30Link0LinkProps,
    sectionDiv0Div1Slider0SliderProps,
    specialitySectionSlideZoomOutDowns,
    specialitySectionSlideZoomOutDownsItemWrapper,
    specialitySectionSlideZoomOutDownsRenderer,
    specialitySectionSlideZoomOutDownsLinkVisible,
    specialitySectionSlideZoomOutDownsLinkRenderer,
    specialitySectionSlideZoomOutDownsImageVisible,
    specialitySectionSlideZoomOutDownsImageRenderer,
    specialitySectionSlideZoomOutDownsH3Visible,
    specialitySectionSlideZoomOutDownsH3Renderer,
    specialitySectionSlideZoomOutDownsLinkProps,
    specialitySectionSlideZoomOutDownsImageProps,
    specialitySectionSlideZoomOutDownsH3Props,
}) => {
    const sliderRef = useRef<Slider | null>(null);
    return (
        <section className="speciality-section section overflow-hidden">
            <div className="container">
                <div className="section-header section-header-one text-center wow slideInLeft" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            {" "}
                            <span className="text-primary">{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className="speciality-slider-info">
                    <Slider ref={sliderRef} className="spciality-slider" {...settings} {...(sectionDiv0Div1Slider0SliderProps ?? {})}>
                        {renderCollectionNode(
                            specialitySectionSlideZoomOutDowns,
                            (item: SpecialitySectionSlideZoomOutDownsItem) => (
                                <div className={item.className ?? "slide-item wow zoomOutDown"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                    <div className={item.div0ClassName ?? "spaciality-item"}>
                                        <div className={item.div0ClassName2 ?? "spaciality-img"}>
                                            {renderItemNode(specialitySectionSlideZoomOutDownsImageVisible, specialitySectionSlideZoomOutDownsImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "img"} {...(typeof specialitySectionSlideZoomOutDownsImageProps === "function" ? specialitySectionSlideZoomOutDownsImageProps(item) : (specialitySectionSlideZoomOutDownsImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                            <span className={item.span0ClassName ?? "spaciality-icon"}>
                                                {renderItemNode(specialitySectionSlideZoomOutDownsImageVisible, specialitySectionSlideZoomOutDownsImageRenderer, item, (
                                                    <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "img"} {...(typeof specialitySectionSlideZoomOutDownsImageProps === "function" ? specialitySectionSlideZoomOutDownsImageProps(item) : (specialitySectionSlideZoomOutDownsImageProps ?? {}))} {...(typeof divDiv0Div0Span0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Span0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Span0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        </div>
                                        {renderItemNode(specialitySectionSlideZoomOutDownsH3Visible, specialitySectionSlideZoomOutDownsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof specialitySectionSlideZoomOutDownsH3Props === "function" ? specialitySectionSlideZoomOutDownsH3Props(item) : (specialitySectionSlideZoomOutDownsH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>
                                                {renderItemNode(specialitySectionSlideZoomOutDownsLinkVisible, specialitySectionSlideZoomOutDownsLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "all_routes.doctorsGrid"} {...(typeof specialitySectionSlideZoomOutDownsLinkProps === "function" ? specialitySectionSlideZoomOutDownsLinkProps(item) : (specialitySectionSlideZoomOutDownsLinkProps ?? {}))} {...(typeof divDiv0H30Link0LinkProps === "function" ? divDiv0H30Link0LinkProps(item) : (divDiv0H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "mb-0"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            ),
                            specialitySectionSlideZoomOutDownsItemWrapper,
                            specialitySectionSlideZoomOutDownsRenderer
                        )}
                    </Slider>
                    <div className="slide-btn">
                        {renderNode(sectionDiv0Div1Div0Button0ButtonVisible, sectionDiv0Div1Div0Button0ButtonRenderer, (
                            <button type="button" className="slick-arrow spciality-prev" {...(sectionDiv0Div1Div0Button0ButtonProps ?? {})}>
                                <i className="isax isax-arrow-left" />
                            </button>
                        ))}
                        {renderNode(sectionDiv0Div1Div0Button1ButtonVisible, sectionDiv0Div1Div0Button1ButtonRenderer, (
                            <button type="button" className="slick-arrow spciality-next" {...(sectionDiv0Div1Div0Button1ButtonProps ?? {})}>
                                <i className="isax isax-arrow-right-1" />
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeOneSpecialitySectionGenerated;
